import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import axios from 'axios';
import config from "../config";
import i18n from "../i18n";
import LandingView from "../views/LandingView";

class LandingController extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: null
    };
  }

  componentDidMount() {
    this.getContent()
      .then(response => {
        this.setState({
          content: response.data.landing
        });
      });
  }

  async getContent() {
    return axios.get(config.endpoints.landing, {
      headers: {
        'Accept-Language': i18n.language
      }
    })
      .catch(error => {
        console.log(error);
      });
  }

  render() {
    return (
      <LandingView
        {...this.props}
        {...this.state}
      />
    );
  }
}

export default withTranslation('local')(LandingController);
